@if ((design$ | async) === 'classic') {
  <div class="container">
    <div class="margin-bottom-10 font-weight-700">
      {{ "auth.login.LOGIN_TITLE" | translate }}
    </div>

    <form (ngSubmit)="login()" [formGroup]="loginForm" class="form">
      <input
        [disabled]="!isLoading()"
        [placeholder]="'auth.login.LOGIN_PLACEHOLDER' | translate"
        class="input"
        formControlName="login"
        name="email"
        type="email"
      />
      <input
        [disabled]="!isLoading()"
        [placeholder]="'auth.login.PASS_PLACEHOLDER' | translate"
        class="input"
        formControlName="password"
        name="pass"
        type="password"
      />

      <div *ngIf="errorStatusMsg()" class="errorStatus">
        {{ errorStatusMsg() | translate }}
      </div>

      <dx-button
        [disabled]="isLoading() || !loginForm.valid"
        [template]="'buttonTemplate'"
        [useSubmitBehavior]="true"
        class="entry-btn"
      >
        <div *dxTemplate="let buttonData of 'buttonTemplate'">
          <fa-icon
            *ngIf="isLoading()"
            [animation]="'spin'"
            [icon]="['fas', 'spinner']"
          ></fa-icon>
          {{ "auth.login.LOGIN" | translate }}
        </div>
      </dx-button>
    </form>
  </div>
} @else {
  <div #overlay  class="overlay">
    <!-- SVG маска для вырезов -->
    <svg
      class="mask-svg"
      height="100%"
      style="position: absolute; top: 0; left: 0; pointer-events: none"
      width="100%"
    >
      <defs>
        <mask #blurMask  id="blur-mask">
          <rect fill="white" height="100%" width="100%" />
          @if (positionInputData().length) {
            @for (pos of positionInputData(); track i; let i = $index) {
              <rect
                [attr.height]="pos.height"
                [attr.rx]="BORDER_RADIUS_INPUT_CUTOUT"
                [attr.ry]="BORDER_RADIUS_INPUT_CUTOUT"
                [attr.width]="pos.width"
                [attr.x]="pos.x"
                [attr.y]="pos.y"
                fill="black" />
            }
          }
        </mask>
      </defs>
    </svg>

    <!-- SVG слой с inner-shadow для рамок -->
    <svg
      class="shadow-svg"
      height="100%"
      style="position: absolute; top: 0; left: 0; pointer-events: none; z-index: 2"
      width="100%"
    >
      <defs>
        <filter height="200%" id="inner-shadow" width="200%" x="-50%" y="-50%">
          <feComponentTransfer in="SourceAlpha" result="invert">
            <feFuncA tableValues="1 0" type="table" />
          </feComponentTransfer>
          <feGaussianBlur in="invert" result="blur" stdDeviation="4.5" />
          <feComposite in="blur" in2="SourceAlpha" operator="in" result="shadow" />
          <feComponentTransfer in="shadow" result="boosted">
            <feFuncA intercept="0" slope="1.5" type="linear" />
          </feComponentTransfer>
          <feFlood flood-color="#fff" result="color" />
          <feComposite in="color" in2="boosted" operator="in" />
        </filter>
      </defs>
      <g filter="url(#inner-shadow)">
        @if (positionInputData().length) {
          @for (pos of positionInputData(); track i; let i = $index) {
            <rect
              [attr.height]="pos.height"
              [attr.rx]="BORDER_RADIUS_INPUT_CUTOUT"
              [attr.ry]="BORDER_RADIUS_INPUT_CUTOUT"
              [attr.width]="pos.width"
              [attr.x]="pos.x"
              [attr.y]="pos.y"
              fill="black" />
          }
        }
      </g>
    </svg>

    <div #overlayFive class="overlay-5"></div>

    <div class="overlay-wrapper">
      <div class="overlay-4">
        <img #logoSvg alt="logo" src="../../../../../assets/images/layout/layout-main-logo-clip.svg" />
        <!-- Play треугольник -->
        <svg
          [attr.height]="positionTriangleData().height"
          [attr.width]="positionTriangleData().width"
          [ngStyle]="{left: positionTriangleData().left, top: positionTriangleData().top}"
          class="play-triangle"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg">
          <polygon fill="#D33C27" points="15,10 15,90 85,50" />
        </svg>
      </div>
        <form (ngSubmit)="login()" [formGroup]="loginForm" class="login-form">
          <div class="overlay-rect">
            <div class="input-wrapper">
              <input
                #input1
                [formControl]="loginForm.controls.login"
                [ngClass]="{
                noEmpty: !!loginForm.controls.login.value,
                invalid:
                  loginForm.controls.login.invalid &&
                  loginForm.controls.login.touched
                }"
                class="input-new input-1"
                name="login"
                type="text"
              />
              <label for="login">{{"auth.login.LOGIN_PLACEHOLDER" | translate }}</label>
              <div *ngIf="loginForm.controls.login.invalid && loginForm.controls.login.touched" class="error-icon">
                <app-icon-error />
              </div>
              <div *ngIf="loginForm.controls.login.invalid && loginForm.controls.login.touched" class="input-wrapper__error-message">
                {{ "auth.login.INVALID_MESS" | translate }}
              </div>
            </div>

            <div class="input-wrapper">
              <input
                #input2
                (focusin)="onFocus()"
                (focusout)="onFocusOut()"
                [formControl]="loginForm.controls.password"
                [ngClass]="{
                noEmpty: !!loginForm.controls.password.value,
                invalid:
                  loginForm.controls.password.invalid &&
                  loginForm.controls.password.touched
              }"
                [type]="isVisiblePassword() ? 'text' : 'password'"
                class="input-new"
                id="pass"
                name="pass"
              />
              <label for="pass">{{"auth.login.PASS_PLACEHOLDER" | translate }}</label>
              <div class="error-icon">
                <button
                  (click)="onVisiblePassword()"
                  (mousedown)="$event.preventDefault()"
                  *ngIf="loginForm.controls.password.value"
                  class="btn-visible-password"
                  type="button"
                >
                  <app-icon-eye
                    *ngIf="!isVisiblePassword()"
                    [color]="getColorIconButton()"
                  />
                  <app-icon-cross-eye
                    *ngIf="isVisiblePassword()"
                    [color]="getColorIconButton()"
                  />
                </button>

                <app-icon-error
                  *ngIf="
                loginForm.controls.password.invalid &&
                loginForm.controls.password.touched
              "
                />
              </div>
              <div
                *ngIf="
                loginForm.controls.password.invalid &&
                loginForm.controls.password.touched"
                  class="input-wrapper__error-message"
                >
                {{ "auth.login.INVALID_MESS" | translate }}
              </div>
              <div *ngIf="errorStatusMsg()" class="input-wrapper__error-message">
                {{ errorStatusMsg() | translate }}
              </div>
            </div>

          </div>
          <button
            [disabled]="isLoading() || loginForm.invalid"
            class="submit-button"
            type="submit"
          >
            {{ "auth.login.LOGIN" | translate }}
          </button>

          <div class="liquid-glass"></div>
        </form>
    </div>
  </div>

  <svg height="270" viewBox="-20 -20 375 290" width="335" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <filter height="200%" id="liquid-glass-filter" width="200%" x="-50%" y="-50%">
        <feTurbulence
          baseFrequency="0.007 0.007"
          numOctaves="2"
          result="noise"
          seed="92"
          type="fractalNoise"
        />
        <feGaussianBlur in="noise" result="blurred" stdDeviation="2" />
        <feDisplacementMap
          in="SourceGraphic"
          in2="blurred"
          result="displaced"
          scale="75"
          xChannelSelector="R"
          yChannelSelector="G"
        />

        <!-- Внешняя тень -->
        <feGaussianBlur in="displaced" result="shadowBlur" stdDeviation="8" />
        <feOffset dx="5" dy="5" in="shadowBlur" result="shadowOffset" />
        <feFlood flood-color="#000000" flood-opacity="0.4" result="shadowColor" />
        <feComposite in="shadowColor" in2="shadowOffset" operator="in" result="shadow" />

        <feMerge>
          <feMergeNode in="shadow" />
          <feMergeNode in="displaced" />
        </feMerge>
      </filter>
    </defs>

    <g opacity="1">
      <g filter="url(#liquid-glass-filter)"></g>
    </g>
  </svg>
}
